const selectMemberInfo = state => {
  return {
    ...state.member
  };
};

const selectAccountInfo = state => {
  return {
    ...state.member.account
  };
};

const selectMembersInfo = state => {
  return {
    ...state.member.members
  };
};

const selectDrawDetail = state => {
  return {
    ...state.member
  };
};

const selectFreezeDetail = state => {
  return {
    ...state.member.freezeDetail
  };
};

const selectDocumentFile = state => {
  return {
    ...state.member.file
  };
};

const selectAgentInfo = state => {
  return {
    ...state.member.agent
  };
};

const selectMemberExpenseByMemberNo = state => {
  return {
    ...state.member.expenses
  };
};

export {
  selectMemberInfo,
  selectAccountInfo,
  selectMembersInfo,
  selectDrawDetail,
  selectDocumentFile,
  selectAgentInfo,
  selectFreezeDetail,
  selectMemberExpenseByMemberNo
};
